import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from "@mui/material"
import AddPhotoIcon from '@mui/icons-material/AddAPhoto';
import { useRef, useState } from "react";
import { MyListApi } from "../utils/restApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";
import { MYLIST_APP } from "../constants/constants";

export const UploadImage = ({ value, label = "Upload", height = '350px', onChange }) => {

    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(value);
    const [preview, setPreview] = useState(null);
    const [open, setOpen] = useState(false);
    const [progress, setProgress] = useState(null);
    const fileUploadRef = useRef(null);

    const handleFileChange = event => {
        setSelectedFile(event.target.files[0]);
        setPreview(URL.createObjectURL(event.target.files[0]));
    }

    const handleInputClick = () => {
        fileUploadRef.current.click();
    }

    const handleClose = (_, reason) => {
        if (reason != 'backdropClick') {
            setOpen(false);
        }
    }

    const handleProgress = p => {
        setProgress(p);
    }

    const handleUpload = () => {
        MyListApi.uploadImage(selectedFile, handleProgress)
            .then(response => {
                setSelectedFile(null);
                setProgress(null);
                setPreview(null);
                setOpen(false);
                setUploadedFile(response.filename);
                onChange?.(response);
            })
            .catch(error => {
                setProgress(null);
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Upload Image</DialogTitle>
                <DialogContent sx={{ justifyItems: 'center' }}>
                    <Box sx={{ border: 1, borderStyle: "dashed", borderColor: "divider", borderRadius: "10px", width: '200px', height: "200px", alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '2px' }}>
                        {preview ? <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} src={preview} /> : null}
                    </Box>
                    {progress !== null ?
                        <LinearProgress variant="determinate" value={progress} />
                    : null}
                </DialogContent>
                <DialogActions>
                    <Button disabled={progress !== null} onClick={() => setOpen(false)}>Cancel</Button>
                    <Button variant="outlined" disabled={progress !== null} onClick={handleInputClick}>Select file</Button>
                    <Button variant="contained" disabled={progress !== null || !selectedFile} onClick={handleUpload}>Upload</Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                <Button variant="outlined" onClick={() => setOpen(true)} startIcon={<AddPhotoIcon />}>{label}</Button>
            </Box>
            <Box sx={{ border: 2, borderStyle: "dashed", borderColor: "divider", borderRadius: "10px", maxHeight: height, minHeight: '120px', alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '4px' }}>
                {uploadedFile ?
                    <img alt="Uploaded" style={{ maxWidth: '100%', maxHeight: height, width: 'auto', height: 'auto', objectFit: 'contain' }} src={`${MYLIST_APP.S3_BUCKET_HOST}/${uploadedFile}`} />
                : <Typography variant="body2" color="text.secondary">No photo added</Typography>}
            </Box>
            <input type="file" accept=".jpg,.jpeg,.png" onChange={handleFileChange} ref={fileUploadRef} hidden />
        </Box>
    )
}